<template>
    <div>
        <m-filters
            v-if="
                vuexActionRemoveQueryElementAndFetch &&
                    vuexActionResetQueryAndFetch &&
                    vuexGetterFilters
            "
            :filters="filters"
            @remove-filter="
                $store.dispatch(vuexActionRemoveQueryElementAndFetch, $event)
            "
            @remove-all="$store.dispatch(vuexActionResetQueryAndFetch, $event)"
        />
        <m-list
            v-if="model && status !== 'loading' && status !== 'error'"
            :router-single-name="routerSingleName"
            :list="model"
        >
            <template slot="list" slot-scope="props">
                <slot name="list" :list="props"></slot>
            </template>
        </m-list>
        <div class="l-tow" v-else-if="status === 'error'">
            <div class="l-row__column">
                <hr class="a-hr" />
                <h1 class="a-title a-title">Wystapił błąd<br /></h1>
                <i style="font-size:.75rem"
                    >Timestamp error: {{ Date.now() }}</i
                >
                <hr class="a-hr" />
            </div>
        </div>
        <a-spinner v-else />
        <a-spinner v-if="status === 'loadingMore'" />
    </div>
</template>

<script>
export default {
    data() {
        return {
            loadNew: false
        }
    },
    props: {
        vuexActionFetch: {
            type: String,
            required: false
        },
        vuexFetchOptions: {
            type: Object,
            required: false
        },
        vuexActionFetchNextPage: {
            type: String,
            required: false
        },
        vuexActionRemoveQueryElementAndFetch: {
            type: String,
            default: null
        },
        vuexActionResetQueryAndFetch: {
            type: String,
            default: null
        },
        vuexGetterModel: {
            type: String,
            required: true
        },
        vuexGetterFilters: {
            type: String,
            default: ''
        },
        vuexGetterStatus: {
            type: String,
            required: true
        },
        routerSingleName: {
            type: String,
            required: true
        }
    },
    computed: {
        model() {
            return this.$store.getters[this.vuexGetterModel]
        },
        status() {
            return this.$store.getters[this.vuexGetterStatus]
        },
        filters() {
            return this.$store.getters[this.vuexGetterFilters]
        }
    },
    watch: {
        loadNew() {
            if (this.loadNew) {
                this.$store
                    .dispatch(
                        this.vuexActionFetchNextPage,
                        this.vuexFetchOptions
                    )
                    .then(() => {
                        this.loadNew = false
                    })
            }
        }
    },
    methods: {
        handleScroll() {
            if (this.status !== 'loadingMore') {
                // set to true if scroll is 100px before bottom
                this.loadNew =
                    window.scrollY + window.innerHeight >=
                    document.body.offsetHeight - 100
            }
        }
    },
    created() {
        // event listener to handle load more after scroll hits bottom
        window.addEventListener('scroll', this.handleScroll)
        // fetch model
        this.$store.dispatch(this.vuexActionFetch, this.vuexFetchOptions)
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll)
    }
}
</script>
